import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from "../../../../environments/environment";

@Injectable({providedIn: 'root'})
export class CitizenHistorySearchService {
    endPoint: string;
    constructor(private http: HttpClient) {
        this.endPoint = environment.api.API_ENDPOINT + '/citizenhistory/emails';
    }

    search(term: string): Observable<string[]> {
        return this.http.get<string[]>(this.endPoint + '?searchTerm=' + term);
    }
}
